var initialState = {
  ui: {
    isRequesting: false
  },
  data: {
    userState: ''
  },
  error: null
};
export default initialState;